import { render, staticRenderFns } from "./DealerWaitDetails.vue?vue&type=template&id=5d7ad2d3"
import script from "./DealerWaitDetails.vue?vue&type=script&lang=js"
export * from "./DealerWaitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports